import React from "react";

function ImportPNR() {
  return <div>ImportPNR</div>;
}

export default ImportPNR;
